import {
  GetIssueTemplateByIssueTypeIssueSubtypeResponseDto,
  useApi,
} from '@issuemanager/api-client';
import { useQuery } from '@tanstack/react-query';

export type UseIssueTemplateByIssueTypeAndIssueSubtype = {
  issueTypeId: string;
  issueSubtypeId?: string;
  enabled?: boolean;
};

export function useIssueTemplateByIssueTypeAndIssueSubtype(
  params: UseIssueTemplateByIssueTypeAndIssueSubtype,
): {
  dataUpdatedAt: number;
  data: GetIssueTemplateByIssueTypeIssueSubtypeResponseDto | undefined;
  isLoading: boolean;
  isFetching: boolean;
} {
  const { issueTypeId, issueSubtypeId, enabled } = params;

  const api = useApi();

  const issueTemplate = useQuery({
    queryKey: [
      'issue-template',
      'by-issue-type-issue-subtype',
      issueTypeId,
      issueSubtypeId,
    ],
    queryFn: () =>
      api.issueTemplatesApi
        .findByIssueTypeAndSubtype(issueTypeId, issueSubtypeId)
        .then((r) => r.data),
    enabled,
    // Note: API now returns 200 with empty object {} when no template exists,
    // instead of 404 error. This is handled gracefully with optional chaining.
  });

  return {
    dataUpdatedAt: issueTemplate.dataUpdatedAt,
    data: issueTemplate.data,
    isLoading: issueTemplate.isLoading,
    isFetching: issueTemplate.isFetching,
  };
}
